module.exports = __webpack_public_path__ + "static/media/astateofreverie-IG.0884d4ef.PNG";